<p-table #dt styleClass="p-datatable-gridlines p-datatable-striped p-datatable-sm" [value]="customers" sortField="Name" [paginator]="true" [rows]="50" [autoLayout]="true">
	<ng-template pTemplate="caption">
		{{dt._totalRecords}} clients
		{{resume(dt)}}
	</ng-template>
	<ng-template pTemplate="header">
		<tr>                   
			<th [pSortableColumn]="'Id'" width="120">
				Id<p-sortIcon [field]="'Id'"></p-sortIcon>
			</th>
			<th [pSortableColumn]="'Name'">Nom<p-sortIcon [field]="'Name'"></p-sortIcon></th>
			<th style="min-width:300px">Email de contact</th>
			<th [pSortableColumn]="'FamilyName'">Famille<p-sortIcon [field]="'FamilyName'"></p-sortIcon></th>
			<th [pSortableColumn]="'ColleagueId'" width="120">Commercial<p-sortIcon [field]="'ColleagueId'"></p-sortIcon></th>
			<!-- <th rowspan="2" >Liste(s) de diffusion</th> -->
		</tr>
		<tr>
        	<th>
				<input pInputText type="text" placeholder="Filtrer par Id" (input)="dt.filter($event.target.value, 'Id', 'contains')">
        	</th>
        	<th><input pInputText type="text" placeholder="Filtrer par nom" (input)="dt.filter($event.target.value, 'Name', 'contains')"></th>
        	<th><input pInputText type="text" placeholder="Filtrer par email" (input)="dt.filter($event.target.value, 'email', 'contains')"></th>
        	<th><input pInputText type="text"  placeholder="Filtrer par famille" (input)="dt.filter($event.target.value, 'FamilyName', 'contains')"></th>
        	<th><input pInputText type="text"  placeholder="Filtrer par commercial" (input)="dt.filter($event.target.value, 'ColleagueId', 'contains')"></th>
        </tr>
	</ng-template>
	<ng-template pTemplate="body" let-row>
		<tr>
			<td>
				{{row.Id}}
			</td>
			<td>{{row.Name}}</td>
			<td>
				{{row.email}}
			</td>
			<td>{{row.FamilyName}}</td>
			<td>{{row.ColleagueId}}</td>
			
		</tr>
	</ng-template>
</p-table>